import * as schema from '../../../api/schema/appGatewayServer'

export const EmptyData: schema.MemoryAlbumPayload = {
  streamerUser: {
    nickname: '',
    iconUrl: '',
  },
  daysFromResister: 0,
  totalLoginDays: 0,
  myRecord: null,
  broadcastViewRecords: [],
  giftRecords: [],
  collabRecords: [],
  chatRecords: [],
}


export const DummyData1: schema.MemoryAlbumPayload = {
  streamerUser: {
    nickname: 'わたなべけん',
    iconUrl:
      'https://image.vlive-lab.gree-services.net/api/v1/image/profile/r8wd3yrcgjzyhcn3dbvzzcqfmw/1653911521',
  },
  daysFromResister: 207,
  totalLoginDays: 365,
  myRecord: {
    resisterAt: '2020-04-01T10:12:11Z',
    firstBroadcastedAt: '2020-04-01T10:12:11Z',
    totalBroadcastViewHour: 14987,
    totalBroadcastHour: 3526,
    winEvents: [
      {
        broadcasterEvent: {
          endAt: '2022-05-13T04:05:06Z',
          headerImageUrl:
            'https://image.vlive-lab.gree-services.net/api/v1/image/event-header/2433/1650867347',
          eventType: 1,
          numberOfWinners: 3,
          threshold: 0,
        },
        broadcasterEventResult: {
          rank: 1,
          score: 100123566,
        },
      },
      {
        broadcasterEvent: {
          endAt: '2022-04-23T04:05:06Z',
          headerImageUrl:
          'https://image.vlive-lab.gree-services.net/api/v1/image/event-header/2431/1650686424',
          eventType: 2,
          numberOfWinners: 3,
          threshold: 0,
        },
        broadcasterEventResult: {
          rank: 2,
          score: 8012356,
        },
      },
      {
        broadcasterEvent: {
          endAt: '2021-09-21T04:05:06Z',
          headerImageUrl:
          'https://image.vlive-lab.gree-services.net/api/v1/image/event-header/2696/1655524809',
          eventType: 3,
          numberOfWinners: 3,
          threshold: 0,
        },
        broadcasterEventResult: {
          rank: 3,
          score: 8012356,
        },
      },
      {
        broadcasterEvent: {
          endAt: '2021-10-10T04:05:06Z',
          headerImageUrl:
          'https://image.vlive-lab.gree-services.net/api/v1/image/event-header/2675/1654153731',
          eventType: 3,
          numberOfWinners: 0, // 過去のイベントの形式では入賞者がthresholdに含まれる
          threshold: 3,
        },
        broadcasterEventResult: {
          rank: 4,
          score: 12356,
        },
      },
    ],
  },
  broadcastViewRecords: [
    {
      streamerUser: {
        nickname: '最大文字数あいうえおかきくけこさしすせそ',
        iconUrl:
          'https://image.vlive-lab.gree-services.net/api/v1/image/profile/71599pmybaaqb5f8tf41r9u5v7/1633416198',  
      },
      firstViewAt: '2019-10-07T20:12:11Z',
      totalViewHour: 345,
    },
    {
      streamerUser: {
        nickname: '最大文字数あいうえおかきくけこさしすせそ',
        iconUrl:
        'https://image.vlive-lab.gree-services.net/api/v1/image/profile/71599pmybaaqb5f8tf41r9u5v7/1633416198',
      },
      firstViewAt: '2019-10-07T20:12:11Z',
      totalViewHour: 245,
    },
    {
      streamerUser: {
        nickname: '最大文字数あいうえおかきくけこさしすせそ',
        iconUrl:
        'https://image.vlive-lab.gree-services.net/api/v1/image/profile/71599pmybaaqb5f8tf41r9u5v7/1633416198',
      },
      firstViewAt: '2019-10-07T20:12:11Z',
      totalViewHour: 145,
    },
  ],
  giftRecords: [
    {
      giftReceiver: {
        nickname: '最大文字数あいうえおかきくけこさしすせそ',
        iconUrl:
          'https://image.vlive-lab.gree-services.net/api/v1/image/profile/e1n6ndwhqjz891jrr3v0g1cetz/1630568759',  
      },
      totalGiftSendCount: 2345,
      firstGiftSendAt: '2022-07-06T00:00:00Z',
      mostSendGift: {
        giftId: 1701,
        giftName: 'ハートの女王の杖エモート',
        giftIconUrl: 'https://storage.googleapis.com/vlive-lab-public-origin/app_image/gift/798ef79613fdc07aa69dd2bdbf85dc78b3669fd2036878efc8847acb8e85da15',
        giftCount: 123,
      }
    },
    {
      giftReceiver: {
        nickname: '最大文字数あいうえおかきくけこさしすせそ',
        iconUrl:
          'https://image.vlive-lab.gree-services.net/api/v1/image/profile/e1n6ndwhqjz891jrr3v0g1cetz/1630568759',  
      },
      totalGiftSendCount: 2345,
      firstGiftSendAt: '2022-07-06T00:00:00Z',
      mostSendGift: {
        giftId: 1701,
        giftName: 'ハートの女王の杖エモート',
        giftIconUrl: 'https://storage.googleapis.com/vlive-lab-public-origin/app_image/gift/798ef79613fdc07aa69dd2bdbf85dc78b3669fd2036878efc8847acb8e85da15',
        giftCount: 123,
      }
    },
    {
      giftReceiver: {
        nickname: '最大文字数あいうえおかきくけこさしすせそ',
        iconUrl:
          'https://image.vlive-lab.gree-services.net/api/v1/image/profile/e1n6ndwhqjz891jrr3v0g1cetz/1630568759',  
      },
      totalGiftSendCount: 2345,
      firstGiftSendAt: '2022-07-06T00:00:00Z',
      mostSendGift: {
        giftId: 1701,
        giftName: 'ハートの女王の杖エモート',
        giftIconUrl: 'https://storage.googleapis.com/vlive-lab-public-origin/app_image/gift/798ef79613fdc07aa69dd2bdbf85dc78b3669fd2036878efc8847acb8e85da15',
        giftCount: 123,
      }
    },
  ],
  collabRecords: [
    {
      collabUser: {
        nickname: '有川ある',
        iconUrl: 'https://image.vlive-lab.gree-services.net/api/v1/image/profile/16emhwzm3mazpawc5gn00n9ett/1639642527',  
      },
      totalCollabHour: 45,
    },
    {
      collabUser: {
        nickname: 'はそた',
        iconUrl: 'https://image.vlive-lab.gree-services.net/api/v1/image/profile/16emhwzm3mazpawc5gn00n9ett/1639642527',  
      },
      totalCollabHour: 25,
    },
    {
      collabUser: {
        nickname: 'ちょーかんたん',
        iconUrl: 'https://image.vlive-lab.gree-services.net/api/v1/image/profile/16emhwzm3mazpawc5gn00n9ett/1639642527',  
      },
      totalCollabHour: 25,
    },
  ],
  chatRecords: [
    {
      chatUser: {
        nickname: '有川ある',
        iconUrl: 'https://image.vlive-lab.gree-services.net/api/v1/image/profile/jqnyf9mt6en11nt0t6fb2jicpt/1633417913',
      },
      totalChatSendCount: 2345,
    },
    {
      chatUser: {
        nickname: '有川ある',
        iconUrl: 'https://image.vlive-lab.gree-services.net/api/v1/image/profile/jqnyf9mt6en11nt0t6fb2jicpt/1633417913',
      },
      totalChatSendCount: 124,
    },
    {
      chatUser: {
        nickname: '有川ある',
        iconUrl: 'https://image.vlive-lab.gree-services.net/api/v1/image/profile/jqnyf9mt6en11nt0t6fb2jicpt/1633417913',
      },
      totalChatSendCount: 55,
    },
  ],
}
